import {
  createAsyncAction,
  createAsyncTypes,
} from 'lib/reduxUtils';

// Async
export const FETCH_INFORMATION_CARD = createAsyncTypes('informationCard/fetchInformationCard');
export const fetchInformationCard = createAsyncAction(FETCH_INFORMATION_CARD);
